import { CreateStoreFromObservable } from './types'

export const storeFromObservable: CreateStoreFromObservable<any> = (v, obs) => {
    let value = v

    obs.subscribe(v => {
        value = v
    })

    return {
        value: () => value,
        changes: () => obs
    }
}
